<template>
    <Dialog title="Manage dashboard" :show="isOpen" :onClose="onClose">
        <div class="actions">
            <el-form inline size="small">
                <el-form-item>
                    <el-select v-model="selectedReport" placeholder="Report" style="width: auto">
                        <el-option v-for="r in reports" :key="r.id" :label="r.name" :value="r.id" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addReportToDashboard" round>
                        Add
                    </el-button>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="newReport" round icon="el-icon-plus" size="small">New report</el-button>
        </div>
        <Table :items="dashboard.reports || []" :columns="columns" :actions="actions" filterProp="name" :loading="loading.dashboard" />

        <ReportDialog :item="item" :isOpen="showEditDialog" :onClose="() => showEditDialog = false" />
    </Dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { cloneDeep } from 'lodash';
import Dialog from '@/components/Dialog';
import Table from '@/components/Table';
import ReportDialog from './EditReportDialog';
import { getRandomColor } from '@/utils/colors';
import { defaultReportItem } from '../constants';

export default {
    data() {
        return {
            columns: [{label: 'Name', prop: 'name'}],
            actions: [
                { name: 'Edit', type: 'primary', onClick: this.editReport },
                { name: 'Remove', type: 'danger', onClick: this.removeReportFromDashboard }
            ],

            item: {},
            selectedReport: null,
            showEditDialog: false,
        }
    },
    props: {
        isOpen: Boolean,
        onClose: Function,
    },
    components: {
        Dialog,
        Table,
        ReportDialog,
    },
    computed: mapGetters(['dashboard', 'reports', 'loading']),
    mounted() {
        if (!this.dashboard) this.getDashboard();
        this.getReports();
    },
    methods: {
        ...mapActions(['getDashboard', 'putDashboard', 'getReports']),
        newReport() {
            this.item = cloneDeep(defaultReportItem);
            this.item.border_color = getRandomColor();
            this.showEditDialog = true;
        },
        editReport(report) {
            this.item = cloneDeep(report);
            this.item.kpi = this.item.kpi?.id;
            this.showEditDialog = true;
        },
        async addReportToDashboard() {
            const { dashboard, selectedReport } = this;
            const { id } = dashboard;

            if (!selectedReport) return;

            const reports = [...dashboard.reports, { id: selectedReport }].map(r => r.id);
            const data = { reports };

            try {
                await this.putDashboard({ id, data });

                this.$message.info(`Report has been added to your dashboard.`);
                this.selectedReport = null;
                this.getDashboard();
            } catch (e) {
                this.$notify.error({
                    title: 'Coludn\'t add the report :(',
                    message: e.message,
                });
            }
        },
        edit(report) {
            this.item = Object.assign({}, report);
            this.item.kpi = null;
            this.item.kpi = this.item.kpi?.id;
            this.showEditDialog = true;
        },
        async removeReportFromDashboard(report) {
            const { dashboard } = this;
            const reports = dashboard.reports.filter(r => r.id !== report.id).map(r => r.id);
            const { id } = dashboard;
            const data = { reports };

            try {
                await this.putDashboard({ id, data });

                this.$message.info(`Report has been removed from your dashboard.`);
                this.getDashboard();
            } catch (e) {
                this.$notify.error({
                    title: 'Coludn\'t remove the report :(',
                    message: e.message,
                });
            }
        },
    }
}
</script>

<style scoped>
.select-report * {
    margin-right: 5px;
}
.actions {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
}
</style>
